import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { sortByIndex } from "../../utils";
import DateInput from "../../components/ui/dateInput";
import { backend, GroupData, SourceData } from "../../services";
import { currentUserGroupFilter } from "../../state/functions";
import { UserShortInfo } from "../../types";
import {
  EventStatsItem,
  hireFunnelTemplate,
  practiceFunnelTemplate,
  saleFunnelTemplate,
  StatsFilters,
} from "../../forms/filters/stats";
import { FormRow, GroupSelect, ManSelector, SelectInput } from "../components";

interface ModalProps {
  onSave: () => void;
  closeModal: () => void;
}

const templateList = [
  {
    value: "1",
    label: "Продажи",
  },
  {
    value: "2",
    label: "Практики",
  },
  {
    value: "3",
    label: "Найм",
  },
]

const SelectFunnelModal: React.FC<ModalProps> = ({ onSave, closeModal }) => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const [filters, setFilters] = useState<StatsFilters>({});
  const [groupList, setGroupList] = useState<GroupData[]>([]);
  const [usersToSelect, setUsersToSelect] = useState<UserShortInfo[]>([]);
  const [sourceList, setSourceList] = useState<SourceData[]>([]);
  const eventTypeNames = State.eventTypes;
  // const [selectedEvents, setSelectedEvents] = useState<EventStatsItem[]>([])

  useEffect(() => {
    setFilters({...State.statsFilters, event_ids: sortByIndex(State.statsFilters.event_ids || [])});
    // setSelectedEvents(State.statsFilters.event_ids || []);
  }, []);

  useEffect(() => {
    if (filters?.group_ids && filters.group_ids.length > 0) {
      const selectedGroup = filters.group_ids[0];
      backend.getAllUsersShorts({ group_id: selectedGroup }).then((res) => {
        setUsersToSelect(res.users);
      });
    }
  }, [filters.group_ids]);

  useEffect(() => {
    backend.getAllGroups().then((res) => {
      setGroupList(res.groups);
    });
    backend.getAllUsersShorts(currentUserGroupFilter()).then((res) => {
      setUsersToSelect(res.users);
    });
    backend.getCustomerSources().then((res) => {
      setSourceList(res.sources);
    });
  }, [filters.group_ids, filters.source_ids]);

  const closeWithSave = () => {
    const rawFilters = { ...filters, event_ids: sortByIndex(filters.event_ids || []) }; // , event_ids: selectedEvents
    if (
      Array.isArray(rawFilters.user_ids) &&
      rawFilters.user_ids.length === 1 &&
      rawFilters.user_ids[0] === 0
    )
      delete rawFilters.user_ids;
    if (
      Array.isArray(rawFilters.group_ids) &&
      rawFilters.group_ids.length === 1 &&
      rawFilters.group_ids[0] === 0
    )
      delete rawFilters.group_ids;
    dispatch(actions.statsFilters(rawFilters));
    onSave();
    closeModal();
  };

  const selectTemplateHandler = (event: any) => {
    const templateId = Number(event.target.value);
    let templateToSelect: EventStatsItem[] = [];
    switch (templateId) {
      case 1:
        templateToSelect = saleFunnelTemplate;
        break;
      case 2:
        templateToSelect = practiceFunnelTemplate;
        break;
      case 3:
        templateToSelect = hireFunnelTemplate;
        break;
    }
    setFilters((prevFilters) => ({
      ...prevFilters,
      event_ids: sortByIndex(templateToSelect),
    }));
    // setSelectedEvents(templateToSelect);
  };

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>Настройка воронки продаж</h3>
      </div>
      <form className="columnCenter">
        <FormRow label="Даты">
          <div className="fieldInput flex between dateFromTo gap24">
            <DateInput
              value={filters.date_start || ""}
              onSelect={(dateTime) =>
                setFilters((prevFilters) => ({
                  ...prevFilters,
                  date_start: dateTime,
                }))
              }
            />
            <DateInput
              value={filters.date_end || ""}
              onSelect={(dateTime) =>
                setFilters((prevFilters) => ({
                  ...prevFilters,
                  date_end: dateTime,
                }))
              }
            />
          </div>
        </FormRow>

        <GroupSelect
          label="Группа"
          groups={groupList}
          value={filters.group_ids ? filters.group_ids[0] : 0}
          onChange={(group) =>
            setFilters((prevFilters) => ({
              ...prevFilters,
              group_ids: [group],
            }))
          }
        />

        <ManSelector
          label="Ответственный"
          users={usersToSelect}
          selectedUserId={filters.user_ids ? filters.user_ids[0] : 0}
          onChange={(id) =>
            setFilters((prevFilters) => ({
              ...prevFilters,
              user_ids: [id],
            }))
          }
        />

        <SelectInput
          label="Источник"
          options={[
            { value: "1", label: "Нет" },
            ...sourceList.map((source) => ({
              value: String(source.id),
              label: source.name,
            })),
          ]}
          onChange={(event) =>
            setFilters((prevFilters) => ({
              ...prevFilters,
              source_ids: [Number(event.target.value)],
            }))
          }
        />

        <SelectInput
          label="Шаблон заполнения"
          options={templateList}
          onChange={selectTemplateHandler}
        />

        {/* Метаданные */}
        <div className="formField formRow commentRow gap12">
          <label>По каким событиям формировать</label>
          <div className="flex columnCenter w100 gap12">
            {(filters.event_ids || []).map((item, index) => (
              <div key={`slct${index}`} className="flex metadataRow w100 gap12">
                {/* Селект для выбора типа события */}
                <select
                  value={item.type_id}
                  onChange={(event) =>
                    setFilters((prevFilters) => {
                      const updatedEvents = [...(prevFilters.event_ids || [])];
                      updatedEvents[index] = {
                        ...updatedEvents[index],
                        type_id: Number(event.target.value),
                      };
                      return {
                        ...prevFilters,
                        event_ids: updatedEvents,
                      };
                    })
                  }
                >
                  {eventTypeNames.map((typeItem) => (
                    <option key={`evt${typeItem.id}`} value={typeItem.id}>
                      {typeItem.name}
                    </option>
                  ))}
                </select>

                {/* Поле для индекса сортировки */}
                <input
                  type="number"
                  placeholder="Индекс сортировки"
                  value={item.sort_index}
                  onChange={(event) =>
                    setFilters((prevFilters) => {
                      const updatedEvents = [...(prevFilters.event_ids || [])];
                      updatedEvents[index] = {
                        ...updatedEvents[index],
                        sort_index: Number(event.target.value),
                      };
                      return {
                        ...prevFilters,
                        event_ids: updatedEvents,
                      };
                    })
                  }
                />

                {/* Кнопка удаления */}
                <button
                  type="button"
                  onClick={() =>
                    setFilters((prevFilters) => {
                      const updatedEvents = [...(prevFilters.event_ids || [])];
                      updatedEvents.splice(index, 1);
                      return {
                        ...prevFilters,
                        event_ids:
                          updatedEvents.length > 0 ? updatedEvents : undefined,
                      };
                    })
                  }
                  className="removeButton"
                >
                  Удалить
                </button>
              </div>
            ))}

            {/* Кнопка добавления нового элемента */}
            <div className="flex w100">
              <button
                className="filterButton"
                type="button"
                onClick={() =>
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    event_ids: [
                      ...(prevFilters.event_ids || []),
                      {
                        type_id: 1,
                        sort_index: (prevFilters.event_ids?.length || 0) + 1,
                      },
                    ],
                  }))
                }
              >
                Добавить тип события
              </button>
            </div>
          </div>
        </div>

        {/* Кнопки действий */}
        <div className="flex between btnRow">
          <button
            className="filterButton"
            type="button"
            onClick={closeWithSave}
          >
            Сформировать
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default SelectFunnelModal;
